// extracted by mini-css-extract-plugin
export var click = "styles-module--click--f912b";
export var image = "styles-module--image--b5c89";
export var item = "styles-module--item--5de7c";
export var text = "styles-module--text--21784";